import React, { useEffect, useState } from "react";
import "./Board.css";
import Ticket from "./trucks/turnero/Ticket";
import { useAuthContext } from "../hooks/useAuthContext";
import ItemBoard from "./ItemBoard";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import { usePathname } from "../context/PathnameProvider";

export default function Board({ itemsOrd, updatePlatillo, selectedDate }) {
  const { register } = useAuthContext();
  const { setImpresi, impresi } = usePathname();
  const [items, setItems] = useState(itemsOrd);
  const [escala, setEscala] = useState(0.9);
  const [dia, setDia] = useState();
  const [ordImprimir, setOrdImprimir] = useState();
  const [impresion, setImpresion] = useState(false);
  const [pantallaC, setPantallaC] = useState(false);
  const [impAut, setImpAut] = useState(impresi);

  const moveItem = (id, data) => {
    setItems((prev) =>
      prev.map((item) =>
        item?.id === id ? { ...item, x: data.x, y: data.y } : item,
      ),
    );
  };

  const minimizeItem = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item?.id === id ? { ...item, minimized: true } : item,
      ),
    );
  };

  const minimizeAll = () => {
    setItems((prev) =>
      prev.map((item) => item && { ...item, minimized: true }),
    );
  };

  const restoreAll = () => {
    setItems((prev) =>
      prev.map((item) => item && { ...item, minimized: false }),
    );
  };

  const restoreItem = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item?.id === id ? { ...item, minimized: false } : item,
      ),
    );
  };

  useEffect(() => {
    if (ordImprimir) {
      setImpresion(true);
    }
  }, [ordImprimir]);

  // useEffect(() => {
  //   if (selectedDate === dia) {
  //     const diferencias = itemsOrd.filter(
  //       (obj1) => obj1 && !items.some((obj2) => obj2?.id === obj1?.id),
  //     );
  //     if (diferencias.length > 0 && impAut) {
  //       diferencias.map((item) => setOrdImprimir(item));
  //     }
  //   }
  // }, [dia, impAut, items, itemsOrd, selectedDate]);

  useEffect(() => {
    setItems(itemsOrd);
    setDia(selectedDate);
  }, [itemsOrd, selectedDate]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setPantallaC(false);
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  return (
    <>
      <h4 className="section-title">TABLERO</h4>

      <div className={pantallaC ? "board pantalla-completa" : "board"}>
        <button
          className="tabOrd"
          onClick={() => setEscala(Math.max(0.5, escala - 0.1))}
          style={{ position: "sticky", top: 5, left: 5, marginLeft: 5 }}
        >
          Zoom out
          <i className="bx bx-zoom-out icon"></i>
        </button>
        <button
          className="tabOrd"
          onClick={() => setEscala(escala + 0.1)}
          style={{ position: "sticky", top: 5, left: 145, marginLeft: 5 }}
        >
          Zoom in
          <i className="bx bx-zoom-in icon"></i>
        </button>
        <button
          className="tabOrd"
          style={{ position: "sticky", top: 5, left: 272, marginLeft: 5 }}
          onClick={() => {
            if (!document.fullscreenElement) {
              document.documentElement.requestFullscreen().catch((err) => {
                console.error(
                  `Error al intentar activar pantalla completa: ${err.message}`,
                );
              });
              setPantallaC(true);
            } else {
              document.exitFullscreen();
              setPantallaC(false);
            }
          }}
        >
          Full screen
          <i className="bx bx-expand icon"></i>
        </button>

        <button
          className="tabOrd"
          onClick={() => minimizeAll()}
          style={{ position: "sticky", top: 5, marginLeft: 5 }}
        >
          Cerrar todo
          <i className="bx bx-archive-in icon"></i>
        </button>
        <button
          className="tabOrd"
          onClick={() => restoreAll()}
          style={{ position: "sticky", top: 5, marginLeft: 5 }}
        >
          Abrir todo
          <i className="bx bx-archive-out icon"></i>
        </button>
        <button
          className="tabOrd"
          onClick={() => {
            setImpAut(!impAut);
            setImpresi(!impAut);
            Cookies.set("impAut", !impAut);
          }}
          style={{
            position: "sticky",
            top: 5,
            marginLeft: 5,
            backgroundColor: impAut ? "green" : "red",
          }}
        >
          Impresion automatica <FontAwesomeIcon icon={impAut ? faCheck : faX} />
        </button>
        {items && items?.filter((item) => item?.minimized).length > 0 && (
          <div className="topBar" style={{ position: "sticky", top: 50 }}>
            {items
              ?.filter((item) => item?.minimized)
              .map((item) => (
                <button
                  key={item.id}
                  className="tabOrd"
                  onClick={() => restoreItem(item.id)}
                >
                  #{item.folio}
                </button>
              ))}
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            // gridTemplateColumns: "repeat(3, 1fr)",
            // gridAutoRows: "min-content",
          }}
        >
          {items
            ?.filter((item) => item && !item.minimized)
            .map((item, index) => {
              return (
                <ItemBoard
                  item={item}
                  moveItem={moveItem}
                  escala={escala}
                  index={index}
                  minimizeItem={minimizeItem}
                  setOrdImprimir={setOrdImprimir}
                  updatePlatillo={updatePlatillo}
                />
              );
            })}
        </div>
        <Ticket
          orden={ordImprimir}
          registro={register}
          impresion={impresion}
          handleClose={() => {}}
          setImpresion={setImpresion}
          cocina={true}
        />
      </div>
    </>
  );
}
